/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Plus': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<rect pid="0" x="7" width="2.222" height="16" rx="1.111" _fill="#fff"/><rect pid="1" y="9" width="2.222" height="16" rx="1.111" transform="rotate(-90 0 9)" _fill="#fff"/>'
  }
})
